import { atom } from "recoil";

export const currentAssetTab = atom<number>({
  key: "currentAssetTab",
  default: 0,
});
